export function createDispatchOrchestratorClient(transport) {
    return {
        /**
         * What the dispatch for one demand has got to
         *
         * Requires scope: dispatch:read
         */
        getDispatchProcess(tenantId, demandId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-processes/${encodeURIComponent(demandId)}`,
                options,
            });
        },
        /**
         * Idempotently apply an authoritative workflow event
         *
         * Requires scope: dispatch:orchestrate
         */
        postTenantsDispatchProcessesEvents(tenantId, demandId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-processes/${encodeURIComponent(demandId)}/events`,
                body,
                options,
            });
        },
        /**
         * The couriers who could take this demand, ranked now
         *
         * Requires scope: dispatch:orchestrate
         */
        rankDispatchCandidates(tenantId, demandId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-processes/${encodeURIComponent(demandId)}/candidates`,
                options,
            });
        },
        /**
         * Send one courier an offer, with the reason an operator gave
         *
         * Requires scope: dispatch:orchestrate
         */
        sendManualRideOffer(tenantId, demandId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/dispatch-processes/${encodeURIComponent(demandId)}/manual-offers`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=dispatch-orchestrator.js.map